<template>
	<path
			class="star star-1"
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M173.666 319.738C267.248 319.738 342.833 243.852 342.833 150.571C342.833 243.852 418.718 319.738 512 319.738C418.718 319.738 342.833 395.323 342.833 488.605C342.833 395.323 267.248 319.738 173.666 319.738Z"
			fill="var(--c-yellow)"
		/>
		<path
			class="star star-2"
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M-2.83718e-05 407.021C51.29 407.021 92.6819 365.329 92.6819 314.339C92.6819 365.329 134.374 407.021 185.364 407.021C134.374 407.021 92.6819 448.412 92.6819 499.702C92.6819 448.412 51.29 407.021 -2.83718e-05 407.021Z"
			fill="var(--c-yellow)"
		/>
		<path
			class="star star-3"
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M53.3896 125.076C115.777 125.076 166.168 74.6854 166.168 12.2976C166.168 74.6854 216.558 125.076 278.946 125.076C216.558 125.076 166.168 175.466 166.168 237.854C166.168 175.466 115.777 125.076 53.3896 125.076Z"
			fill="var(--c-yellow)"
		/>
</template>

<style scoped>
.icon-stars {
  overflow: visible;
}

.star {
  transform-origin: center;
  transition: fill 0.3s ease;
}

.star-1 {
  animation: ping-stars 4s ease-in-out infinite;
  animation-delay: 0s;
}

.star-2 {
  animation: ping-stars 2.5s ease-in-out infinite;
  animation-delay: 1s;
}

.star-3 {
  animation: ping-stars 3s ease-in-out infinite;
  animation-delay: 2s;
}

@keyframes ping-stars {
  0% {
    transform: scale(1);
    fill: var(--c-main);
    opacity: 0;
  }

  50% {
    transform: scale(1.375);
    fill: var(--c-yellow);
    opacity: 1;
  }

  100% {
    transform: scale(1);
    fill: var(--c-main);
    opacity: 0;
  }
}
</style>
